import React from 'react';
import { useNavigate } from 'react-router-dom';
import heroImage from '../../assets/foto_4_grid.png';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            ROMPENDO REGRAS ,<br />
            VESTINDO ATITUDE<br />
            VISTA - SE COM<br />
            PERSONALIDADE.
          </h1>
          <p className="hero-description">
            Streetwear brasileiro com atitude. Cada peça HAKA é expressão, pertencimento e confiança para quem vive o street de verdade.
          </p>
          <div className="hero-actions">
            <button className="btn btn-outline" onClick={() => navigate('/catalog')}>
              <span>Compre a Nova Coleção</span>
            </button>
            <button className="btn btn-filled" onClick={() => navigate('/catalog')}>
              <span>Catálogo</span>
            </button>
          </div>
        </div>
        <div className="hero-image">
          <img src={heroImage} alt="HAKA Collection" className="hero-image-content" loading="lazy" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
